import { useOutletContext } from '@remix-run/react';
import { FooterReferralLink } from '@shared/dream-components';
import classNames from 'classnames';
import { t } from 'i18next';

import type { OutletContext } from '~/interfaces/outlet_context';

import Logo from '../Logo';
import Typography from '../Typography';

interface Props {
  color?: string;
  className?: string;
  utmMedium?: string;
  variant?: 'default' | 'pill';
}

const PoweredByBeehiiv = ({ color, className, utmMedium = 'footer', variant = 'default' }: Props) => {
  const { publicationBeehiivBranding, publicationName, publicationLogoUrl, publicationUtmSource } =
    useOutletContext<OutletContext>();

  if (!publicationBeehiivBranding) return null;

  const isPill = variant === 'pill';

  if (isPill) {
    return (
      <div className="flex justify-center py-20">
        <FooterReferralLink
          publicationName={publicationName ?? ''}
          publicationLogoUrl={publicationLogoUrl}
          utmSource={publicationUtmSource}
          utmMedium={utmMedium}
          className="flex items-center gap-1 rounded-full border border-black/10 bg-white px-3 py-1"
        >
          <div className="flex shrink-0 items-center justify-center size-6">
            <Logo className="size-[15px]" />
          </div>
          <span className="text-[11px] font-normal leading-4 tracking-[-0.11px] text-black/50">
            {t('shared.cta.powered_by_beehiiv') || 'Powered by beehiiv'}
          </span>
        </FooterReferralLink>
      </div>
    );
  }

  return (
    <div className="w-fit" color={color}>
      <Typography as="span">
        <FooterReferralLink
          publicationName={publicationName ?? ''}
          publicationLogoUrl={publicationLogoUrl}
          utmSource={publicationUtmSource}
          utmMedium={utmMedium}
          className={classNames('extra-light flex items-center rounded border px-3 py-2 text-xs', className)}
          style={{
            borderColor: color,
            color,
          }}
        >
          <Logo className="mr-2 h-4 w-4" />
          <Typography as="span" color={color}>
            {t('shared.cta.powered_by_beehiiv') || 'Powered by beehiiv'}
          </Typography>
        </FooterReferralLink>
      </Typography>
    </div>
  );
};

export default PoweredByBeehiiv;
